import React from 'react';
import Toast from 'sushiweb/Toast';

export const ToastBox = ({
  show = false,
  align = 'bottom',
  text = '',
  autoHideDuration = 5,
  type = 'success',
  onClose,
}) => {
  let ToastTemplate = (
    <Toast
      show={show}
      align={align}
      onClose={onClose}
      text={text}
      type={type}
      autoHideDuration={autoHideDuration}
    />
  );
  return ToastTemplate;
};
